module.exports = __webpack_public_path__ + "static/media/Luxo.3b213580.png";